import React from 'react';
import { useTranslation } from 'react-i18next';
import { MainTitle, Spinner } from '../../../common/index.jsx';
import { useGetSensorsWithGraphableAttributesQuery } from '../../../../redux/services/sensors.jsx';
import {
  useGetSensorValuesPreviewMutation,
  useGetSensorValuesStatisticsMutation,
} from '../../../../redux/services/sensorValues.jsx';
import { ParametersForm } from './components/ParametersForm.jsx';
import { CurrentSensorValues } from './components/CurrentSensorValues.jsx';
import { SensorValuesChart } from './components/SensorValuesChart.jsx';
import { StatisticsForm } from './components/StatisticsForm.jsx';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../../../utils/helpers/ApiClient.jsx';
import { ArrowLeftOutlined } from '@ant-design/icons';

export function MeteoStationPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    data: sensorsWithGraphableAttributes,
    isLoading: isLoadingAttributes,
  } = useGetSensorsWithGraphableAttributesQuery();

  const [
    getSensorValuesPreview,
    { data: previewData, isLoading: isLoadingPreview },
  ] = useGetSensorValuesPreviewMutation();
  const [getSensorValuesStatistics, { data: statisticsData }] =
    useGetSensorValuesStatisticsMutation();

  const handleSubmit = (data) => {
    getSensorValuesPreview(data);
  };

  const handleStatisticsSubmit = (data) => {
    getSensorValuesStatistics(data);
  };

  return isLoadingAttributes ? (
    <Spinner />
  ) : (
    <>
      <MainTitle
        title={t('Meteostanica fakulty FRI')}
        actions={[
          {
            onClick: () => navigate(routes.homePage),
            title: t('Späť'),
            icon: <ArrowLeftOutlined />,
          },
        ]}
      />

      <CurrentSensorValues
        sensorsWithGraphableAttributes={sensorsWithGraphableAttributes}
      />

      <ParametersForm
        onSubmit={handleSubmit}
        sensorsWithGraphableAttributes={sensorsWithGraphableAttributes}
      />

      <SensorValuesChart
        previewData={previewData}
        isLoading={isLoadingPreview}
      />

      <StatisticsForm
        sensorsWithGraphableAttributes={sensorsWithGraphableAttributes}
        onSubmit={handleStatisticsSubmit}
        statisticsData={statisticsData}
      />
    </>
  );
}

export default MeteoStationPage;
